import React, { useState, useEffect } from "react";
import MainModal from "./MainModal";
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import fetchBusinesses from "../../constants/businesses";
import { useStateValue } from "../../state/context";


import {getFatherVerticals, getAgentsForMaps} from "../../utils/ParserUtilities";
import {provinceArrEsp} from "../../constants/provinces"

import "../../styles/JobsMaps/jobs-maps-filter-modal.css";
import 'react-datepicker/dist/react-datepicker.css';

const JobsMapsFilterModal = props => {

    const [verticals, setVerticals] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [business, setBusiness] = useState([]);
    const [agents, setAgents] = useState([]);
    const [modalWidth, setModalWidth] = useState(1000);


    const [jobType, setJobType] = useState([{value:[{value: "lead", label: "Lead"},{value: "fixed",label: "PC"}], label: "Todos"},{value: "lead", label: "Lead"},{value: "fixed",label: "PC"}]);
    const [totalSlots, setTotalSlots] = useState([{value: "Todos", label: "Todos"},{value: 1, label: 1},{value: 3,label: 3}]);
    const [empty, setEmpty] = useState([{value: "All", label: "Todos"},{value: "Yes", label: "Solo Vacios"}]);
    const [showWollers, setShowWollers] = useState([{value: "Si", label: "Si"},{value: "No", label: "No"}]);
    const [jobStates, setJobStates] = useState();
    const [{ user, currentSession }, dispatch] = useStateValue();

    const {setSelectedVerticals, getAllJobs, selectedVerticals, onClose, isVisible,
        setSelectedProvinces, selectedProvinces, dateRange, setDateRange,
        setSelectedBusiness, selectedBusiness, setSelectedTotalSlots, selectedTotalSlots,setSelectedJobStates,selectedJobStates,
        setSelectedEmpty, selectedEmpty, selectedAgents, setSelectedAgents, setSelectedShowWollers,selectedJobType,setSelectedJobType,
        selectedShowWollers, 
    } = props;


    const handleVerticalChange = e => setSelectedVerticals(e);
    const handleProvincesChange = e => setSelectedProvinces(e);
    const handleBusinessChange = e => setSelectedBusiness(e);
    const handleTotalSlotsChange = e => setSelectedTotalSlots(e);
    const handleJobStateChange = e => setSelectedJobStates(e);
    const handleEmptyChange = e => setSelectedEmpty(e);
    const handleJobType = e => setSelectedJobType(e);
    const handleAgentsChange = e => setSelectedAgents([...e]);
    const handleShowWollersChange = e => setSelectedShowWollers(e);

    const [startDate, endDate] = dateRange;

    useEffect(()=> {
        getProvinces();
        getVerticals(); 
        getBusiness();
        getAgents();
        processStates(currentSession.searchItemsFilter.jobStateArr)
        if(window.innerWidth <= 800){
            setModalWidth("100%")
        }
    },[]);

    const processStates = async (states) => {
        let processedStates = []
        states.map(state => {
            if (state.collapsed != undefined) {
                state.items.map((subStale) => {
                    processedStates.push({
                        value: subStale.id,
                        label: subStale.name
                    })
                })
            } else {
                processedStates.push({
                    value: state.id,
                    label: state.name
                })
            }
        })
        setJobStates(processedStates);
    }
    const getProvinces = async () => {
        const formatedProvinces = [];
        provinceArrEsp.map( province => {
            let formatedVertical = {
                value: province.id,
                label: province.name
            }
            formatedProvinces.push(formatedVertical);
        })
        setProvinces(formatedProvinces);
    }

    const getVerticals = async () => {
        const res = await getFatherVerticals();
        const formatedVerticals = [];
        res.map( vert => {
            let formatedVertical = {
                value: vert.id,
                label: vert.get("Type")
            }
            formatedVerticals.push(formatedVertical)
        })
        setVerticals(formatedVerticals);
    }

    const getBusiness = async () => {
        let res = await fetchBusinesses([],true);
        const formatedBusinesses = [];
        res.map( business => {
            let formatedBusiness = {
                value: business.id,
                label: business.name
            }
            formatedBusinesses.push(formatedBusiness)
        })
        setBusiness(formatedBusinesses);
    }

    const getAgents = async () => {
        let res = await getAgentsForMaps();
        const formatedAgents = [];
        res.map( agent => {
            let formatedAgent = {
                value: agent.id,
                label: agent.get("Name")
            }
            formatedAgents.push(formatedAgent)
        })
        setAgents(formatedAgents);
    }

    return(
        <MainModal
            style={{ height: "auto", width: modalWidth }}
            title={"Filtros"}
            subtitle={""}
            isVisible={isVisible}
            onClose={onClose}
        >
            <div className="maps-filter-modal-wrapper">
                <p className="maps-filter-modal-title">Gremios:</p>
                <Select
                    isMulti
                    options={verticals}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    defaultValue={selectedVerticals}
                    onChange={handleVerticalChange} 
                />
                {
                    !user.isGoldWoller && (
                        <>
                            <p className="maps-filter-medium-modal-title">Wollers</p>
                            <Select
                                options={showWollers}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                defaultValue={selectedShowWollers}
                                onChange={handleShowWollersChange} 
                            />
                        </>
                    )
                }
                
            </div>

            <div className="maps-filter-modal-wrapper">
                <p className="maps-filter-modal-title">Provincias:</p>
                <Select
                    isMulti
                    options={provinces}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    defaultValue={selectedProvinces}
                    onChange={handleProvincesChange} 
                />
            </div>
            {
                !user.isGoldWoller && (
                    <>
                        <div className="maps-filter-modal-wrapper">
                            <p className="maps-filter-modal-title">Business:</p>
                            <Select
                                isMulti
                                options={business}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                defaultValue={selectedBusiness}
                                onChange={handleBusinessChange} 
                            />     
                            <p className="maps-filter-medium-modal-title">Agentes:</p>
                            <Select
                                options={agents}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                defaultValue={selectedAgents}
                                onChange={handleAgentsChange}
                            />
                        </div>

                        <div className="maps-filter-modal-wrapper">
                            <p className="maps-filter-modal-title">Estado:</p>
                            <Select
                                isMulti
                                options={jobStates}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                defaultValue={selectedJobStates}
                                onChange={handleJobStateChange} 
                            />
                      
                            <p className="maps-filter-modal-title">Totalslots:</p>
                            <Select
                                options={totalSlots}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                defaultValue={selectedTotalSlots}
                                onChange={handleTotalSlotsChange} 
                            />
                              </div>
                        <div className="maps-filter-modal-wrapper">
                            <p className="maps-filter-modal-title">Vacio:</p>
                            <Select
                                options={empty}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                defaultValue={selectedEmpty}
                                onChange={handleEmptyChange} 
                            />  
                            <p className="maps-filter-medium-modal-title">Tipo de servicio:</p>
                            <Select
                                options={jobType}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                defaultValue={selectedJobType}
                                onChange={handleJobType} 
                            />  
                        </div>
                    </>
                )
            }

            <div className="maps-filter-modal-wrapper">
                <p className="maps-filter-modal-title">Fecha de creación:</p>
                <DatePicker
                    className="maps-filter-datepicker"
                    dateFormat={" dd/MM/yyyy "}
                    selectsRange={true}
                    openToDate={new Date()}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                        setDateRange(update);
                    }}
                />
            </div>
            
            <div className="maps-filter-modal-wrapper">
                <button onClick={() => {getAllJobs(); onClose();}} className="maps-filter-modal-button">Filtrar</button>
            </div>
            
        </MainModal>
    )
}

export default JobsMapsFilterModal;